export const TEMPLATE_FORMATS = ["pdf", "web"] as const

export type TemplateFormat = (typeof TEMPLATE_FORMATS)[number]

export const TEMPLATE_FORMAT_LABELS: Record<TemplateFormat, string> = {
  pdf: "PDF Document",
  web: "Deal Form",
}

export const WEB_TEMPLATE_BLOCK_TYPES = ["heading", "paragraph", "merge_value", "input"] as const

export type WebTemplateBlockType = (typeof WEB_TEMPLATE_BLOCK_TYPES)[number]

export const WEB_TEMPLATE_INPUT_TYPES = ["text", "textarea", "date", "checkbox"] as const

export type WebTemplateInputType = (typeof WEB_TEMPLATE_INPUT_TYPES)[number]

export type WebTemplateSelectOption = {
  value: string
  label: string
}

export type WebTemplateHeadingBlock = {
  id: string
  type: "heading"
  text: string
  level: 1 | 2 | 3
}

export type WebTemplateParagraphBlock = {
  id: string
  type: "paragraph"
  text: string
}

export type WebTemplateMergeValueBlock = {
  id: string
  type: "merge_value"
  label: string
  definitionKey: string
  helpText?: string
}

export type WebTemplateInputBlock = {
  id: string
  type: "input"
  key: string
  label: string
  inputType: WebTemplateInputType
  required: boolean
  helpText?: string
  placeholder?: string
}

export type WebTemplateBlock =
  | WebTemplateHeadingBlock
  | WebTemplateParagraphBlock
  | WebTemplateMergeValueBlock
  | WebTemplateInputBlock

const INLINE_MERGE_TOKEN_PATTERN = /\{\{\s*([a-z][a-z0-9_.]*)\s*\}\}/g

export function extractInlineMergeFieldKeys(value: string | undefined | null) {
  if (!value) {
    return []
  }

  const matches = Array.from(value.matchAll(INLINE_MERGE_TOKEN_PATTERN))
  return Array.from(new Set(matches.map((match) => match[1]).filter((key): key is string => !!key)))
}

export function resolveInlineMergeTokens(
  value: string | undefined | null,
  resolvedValues: Record<string, string>,
) {
  if (!value) {
    return undefined
  }

  return value.replace(INLINE_MERGE_TOKEN_PATTERN, (_match, definitionKey: string) => {
    return resolvedValues[definitionKey] ?? ""
  })
}
